import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

import { UBISOFT_CONNECT_PLATFORM_TYPES } from 'modules/ubisoft-connect-service/constants';
import { IPlatformDisplayProps } from 'types/platforms';

const PLATFORM_DISPLAY_NAMES: { [key in string]: string } = {
    [PLATFORM_TYPES.PC]: 'Ubisoft Connect PC',
    [PLATFORM_TYPES.XONE]: 'Xbox One',
    [PLATFORM_TYPES.PS4]: 'PlayStation 4',
    [PLATFORM_TYPES.SWITCH]: 'Nintendo Switch',
    [PLATFORM_TYPES.WEB]: 'Web',
    [PLATFORM_TYPES.MOBILE]: 'Mobile',
    [PLATFORM_TYPES.IOS]: 'iOS',
    [PLATFORM_TYPES.ANDROID]: 'Android',
    [PLATFORM_TYPES.OCULUSVR]: 'Oculus VR',
    [PLATFORM_TYPES.STEAMVR]: 'Steam VR',
    [PLATFORM_TYPES.STADIA]: 'Google Stadia',
    [PLATFORM_TYPES.EPIC]: 'Epic Games Store',
    [PLATFORM_TYPES.XSX]: 'Xbox Series X | S',
    [PLATFORM_TYPES.PS5]: 'PlayStation 5',
    [PLATFORM_TYPES.LUNA]: 'Amazon Luna'
};

export const PLATFORM_DISPLAY_PROPS: { [key: string]: IPlatformDisplayProps} = {
    [PLATFORM_TYPES.PC]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.PC],
        isLinkable: true,
        iconClass: UBISOFT_CONNECT_PLATFORM_TYPES.UPLAY
    },
    [PLATFORM_TYPES.XONE]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.XONE],
        linkAppText: 'platform-selection__link-xbox-account',
        isLinkable: true,
        iconClass: UBISOFT_CONNECT_PLATFORM_TYPES.XBL
    },
    [PLATFORM_TYPES.PS4]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.PS4],
        linkAppText: 'platform-selection__link-psn-account',
        isLinkable: true,
        iconClass: UBISOFT_CONNECT_PLATFORM_TYPES.PSN
    },
    [PLATFORM_TYPES.SWITCH]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.SWITCH],
        isLinkable: false,
        iconClass: UBISOFT_CONNECT_PLATFORM_TYPES.SWITCH
    },
    [PLATFORM_TYPES.WEB]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.WEB],
        isLinkable: false,
        iconClass: UBISOFT_CONNECT_PLATFORM_TYPES.WEB
    },
    [PLATFORM_TYPES.MOBILE]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.MOBILE],
        isLinkable: false,
        iconClass: UBISOFT_CONNECT_PLATFORM_TYPES.MOBILE
    },
    [PLATFORM_TYPES.IOS]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.IOS],
        isLinkable: false,
        iconClass: UBISOFT_CONNECT_PLATFORM_TYPES.IOS
    },
    [PLATFORM_TYPES.ANDROID]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.ANDROID],
        isLinkable: false,
        iconClass: UBISOFT_CONNECT_PLATFORM_TYPES.ANDROID
    },
    [PLATFORM_TYPES.OCULUSVR]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.OCULUSVR],
        isLinkable: false,
        iconClass: UBISOFT_CONNECT_PLATFORM_TYPES.OCULUSVR
    },
    [PLATFORM_TYPES.STEAMVR]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.STEAMVR],
        isLinkable: false,
        iconClass: UBISOFT_CONNECT_PLATFORM_TYPES.STEAMVR
    },
    [PLATFORM_TYPES.STADIA]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.STADIA],
        isLinkable: true,
        iconClass: String(PLATFORM_TYPES.STADIA).toLowerCase()
    },
    [PLATFORM_TYPES.EPIC]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.EPIC],
        isLinkable: false,
        iconClass: UBISOFT_CONNECT_PLATFORM_TYPES.EPIC
    },
    [PLATFORM_TYPES.XSX]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.XSX],
        isLinkable: true,
        linkAppText: 'platform-selection__link-xbox-account',
        iconClass: String(PLATFORM_TYPES.XSX).toLowerCase()
    },
    [PLATFORM_TYPES.PS5]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.PS5],
        isLinkable: true,
        linkAppText: 'platform-selection__link-psn-account',
        iconClass: String(PLATFORM_TYPES.PS5).toLowerCase()
    },
    [PLATFORM_TYPES.LUNA]: {
        name: PLATFORM_DISPLAY_NAMES[PLATFORM_TYPES.LUNA],
        isLinkable: false,
        iconClass: String(PLATFORM_TYPES.LUNA).toLowerCase()
    }
};
